import React,{useRef, useState} from 'react'
import './footer.css'

import { Link as RouterLink } from 'react-router-dom'

// import demo from './footerjs'
// import all_data from './footerjs'
import { demo, demo2, leetdemo, lindemo,maildemo } from './footerjs'
import { toast, Bounce } from 'react-toastify';
import { Button } from '../../style/button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart, faPaste } from '@fortawesome/free-solid-svg-icons'
import git_ from '../../Images/git.jpeg'
import linkedin  from '../../Images/linkedin.png'
import leetcode  from '../../Images/leetcode.png'
import Gmail  from '../../Images/Gmail.png'
import insta  from '../../Images/insta.png'

import emailjs from '@emailjs/browser'

const Footer = () => {
  const form = useRef();
const tostmes =()=>{
  toast.info('This is not curently available!', {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
    } )
}
const tosterr =()=>{
  toast.error('Sorry! you dont have permision to access', {
    position: "bottom-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
    } )
}
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
    .sendForm('service_q59ubfo', 'template_wkuqjsl', form.current, {
      publicKey: 'mEeh9ttZHVrUsMY4L',
    })
    .then(
      () => {
        toast.success('Subscribed 👍', {
          position: "top-right",
          autoClose: 3001,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          transition: Bounce,
          })
      },
      (error) => {
        console.log('FAILED...', error.text);
      },
    );
    }
  return (
    <div name = 'contact' className='footer'>
        <div className="upper footer">
            <div className='f-text'>
            <span>Am  I Capable !?</span>                        
            <span>Talk To Me Today  </span>                        
         
            </div>
            <div className="blur footerblur"></div>
              <div><Button className='btn ftrbtn' onClick={lindemo}> Contact</Button></div>

        <div className="blur footerblurtwo"></div>
        </div>

        <div className="tech-lower-footer">
          <div className="tf-container">
            <div className='tf-column'>
              <h4>About Us</h4>
              <ul>
                <li><RouterLink to='/Personal' className="tf-link">Hobbies</RouterLink></li>
                <li><RouterLink to='/Personal' className="tf-link">Certificates</RouterLink></li>
                <li onClick={tostmes} className="tf-link">Blog</li>
                <li onClick={tostmes} className="tf-link">FAQ</li>
              </ul>
            </div>
            
            <div className='tf-column'>
              <h4>Resources</h4>
              <ul>
                <li onClick={tostmes} className="tf-link">Docs</li>
                <li onClick={tosterr} className="tf-link">Drive</li>
                <li><RouterLink to='/Personal' className="tf-link">Codes</RouterLink></li>
                <li onClick={tosterr} className="tf-link">Cloud</li>
              </ul>
            </div>
            
            <div className='tf-column form-col'>
              <h4>Newsletter</h4>
              <ul>
                <li onClick={tostmes} className="tf-link">Feedback</li>
                <li onClick={tostmes} className="tf-link">Assistant</li>
              </ul>
              <form className='tf-form' ref={form} onSubmit={sendEmail}>
                <input type='email' name='user_email' placeholder='Enter your Email Address' required />
                <button type="submit" className="tf-btn">Subscribe</button>
              </form>
            </div>
          </div>

          <div className="tf-bottom-bar">
            <div className="tf-socials">
              <img src={git_} alt="GitHub" onClick={demo} />
              <img src={linkedin} alt="linkedin" onClick={lindemo} />
              <img src={leetcode} alt="leetcode" onClick={leetdemo} />
              <img src={Gmail} alt="Gmail" onClick={maildemo} />
              <img src={insta} alt="intagram" onClick={demo2} />
            </div>
            <div className='tf-copyright'>
              <span>Made with love <FontAwesomeIcon icon={faHeart} className="heart-icon" /></span>
              {/* <span>Chat-GPT Free <FontAwesomeIcon icon={faPaste} /></span> */}
            </div>
          </div>
        </div>
         
      </div>
  )
}
export default Footer